
import { sanitizeForTTS, estimateDuration } from './textProcessing';
import { validateLanguageContent, getLanguageModeLabel } from '@/utils/languageValidation';
import { LanguageMode } from '../types/audioTypes';

export interface ProcessedTextResult {
  processedText: string;
  isTextValid: boolean;
  isFinalTextValid: boolean;
  estimatedDuration: number;
  validation?: any;
}

export const processTextForLanguage = (
  text: string, 
  language: LanguageMode
): ProcessedTextResult => {
  if (!text) return {
    processedText: '',
    isTextValid: false,
    isFinalTextValid: false,
    estimatedDuration: 0
  };

  // Validate language content first
  const validation = validateLanguageContent(text, language);
  if (!validation.isValid) {
    return {
      processedText: '',
      isTextValid: false,
      isFinalTextValid: false,
      estimatedDuration: 0,
      validation
    };
  }

  const sanitized = sanitizeForTTS(text);
  const blocks = sanitized.split('\n\n');
  let outputLines: string[] = [];
  
  blocks.forEach(block => {
    const lines = block.split('\n').filter(Boolean);
    
    if (language === 'both') {
      outputLines.push(...lines);
    } else if (language === 'english') {
      outputLines.push(
        ...lines.filter(line => 
          !line.match(/[\u4e00-\u9fa5]/) && line.match(/[a-zA-Z]/)
        )
      );
    } else if (language === 'chinese') {
      outputLines.push(
        ...lines.filter(line => 
          line.match(/[\u4e00-\u9fa5]/)
        )
      );
    }
  });
  
  const processedText = outputLines.filter(Boolean).join('\n\n');
  const finalProcessedText = sanitizeForTTS(processedText);
  const isTextValid = processedText.length > 0;
  const isFinalTextValid = finalProcessedText.length > 10 && finalProcessedText.length < 4000;
  const estimatedDuration = estimateDuration(finalProcessedText);

  return {
    processedText: finalProcessedText,
    isTextValid,
    isFinalTextValid,
    estimatedDuration,
    validation
  };
};
